<template>
  <div
    id="resetPassword"
    class="authentication-container"
    :class="{'authentication-container-mobile': isMobileSize}"
  >

    <!-- LEFT SIDE -->

    <left-side v-if="!isMobileSize"/>

    <!-- RIGHT SIDE -->

    <div class="right-side">

      <!-- TITLE -->

      <div class="title">
        <h3 class="title-header">Set password</h3>
      </div>

      <!-- INPUTS -->

      <form
        class="content form"
        @submit.prevent="reset"
      >
        <div class="inputs">
          <div class="input-container">
            <label
              for="password"
              class="label"
            >{{ memberMetadata.fields.password.label }}</label>
            <input
              type="password"
              id="password"
              class="primary-input"
              v-model="password"
              :class="{error: $v.credentials.password.$error}"
            >
            <password-validation-message
              :validation="$v.credentials.password"
              :metadata="memberMetadata.fields.password"
              :newPassword="true"
            />
          </div>
          <div class="input-container">
            <label
              for="confirmPassword"
              class="label"
            >Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              class="primary-input"
              v-model="$v.credentials.confirmPassword.$model"
              :class="[$v.credentials.confirmPassword.$error ? 'error' : null,
                            $v.credentials.confirmPassword.$dirty &&
                            !$v.credentials.confirmPassword.$invalid ? 'success' : null]"
            >
            <password-validation-message
              :validation="$v.credentials.confirmPassword"
              :confirmPassword="true"
            />
          </div>
        </div>

        <!-- ACTION -->

        <div class="actions">
          <CoreButton
            type="submit"
            :disabled="(!password || !credentials.confirmPassword)"
            :loading="isLoading"
          >
            Set password
          </CoreButton>
        </div>
      </form>

      <!-- GO TO LOGIN -->

      <div class="go-to-login">
        <p>Already have an account?
          <router-link
            to="/login"
            class="link"
          >Log in</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import server, { createValidator } from '../server'
import { sameAs } from 'vuelidate/lib/validators'
import { mixin as clickout } from 'vue-clickout'
import { PandaService } from '../utils/request'
import { createToastNotification } from '../utils/toast'
import { WaitStates } from '../utils/vuewait'

const CoreButton = () => import(
  /* webpackChunkName: "CoreButton" */ './../components/Core/CoreButton.vue'
)
const LeftSide = () => import(
  /* webpackChunkName: "LeftSide" */ '../components/LeftSide'
)
const PasswordValidationMessage = () => import(
  /* webpackChunkName: "PasswordValidationMessage" */ './../components/PasswordValidationMessage'
)

export default {
  mixins: [clickout],
  name: 'ResetPassword',
  data () {
    return {
      state: this.$route.query.state,
      password: null,
      credentials: {
        password: null,
        confirmPassword: null
      },
      memberMetadata: server.metadata,
      token: null
    }
  },
  validations () {
    return {
      credentials: {
        password: createValidator(this.memberMetadata.fields.password),
        confirmPassword: {
          sameAs: sameAs(() => this.password)
        }
      }
    }
  },
  computed: {
    query () {
      let queries = {}
      if (this.state) {
        queries.organizationId = this.state
      }
      return queries
    },
    isLoading () {
      return this.$wait.is(WaitStates.RESET_PASSWORD_LOADING)
    },
    isMobileSize () {
      return window.innerWidth <= 768
    }
  },
  methods: {
    async reset () {
      this.$v.credentials.password.$model = this.password
      this.$v.credentials.$touch()
      if (this.$v.credentials.$invalid) return

      const form = {
        password: this.credentials.confirmPassword,
        resetPasswordToken: this.token
      }
      this.$wait.start(WaitStates.RESET_PASSWORD_LOADING)
      const { status, statusText } = await PandaService({
        url: 'passwords',
        method: 'RESET',
        data: form
      })
      this.$wait.end(WaitStates.RESET_PASSWORD_LOADING)
      if (status === 200) {
        createToastNotification(statusText, { type: 'success', position: 'bottom' })
        if (this.state) {
          this.$router.push({ path: '/login', query: this.query })
        } else {
          this.$router.push('login')
        }
      }
    }
  },
  mounted () {
    this.token = this.$route.query.t_
  },
  components: {
    LeftSide,
    PasswordValidationMessage,
    CoreButton
  }
}
</script>
